import { ModalStates } from '@components'

import { ConnectionFailedModalBody } from '../elements/ConnectionFailedModalBody'
import { ErrorModalBody } from '../elements/ErrorModalBody'
import { LoadingModalBody } from '../elements/LoadingModalBody'
import { SuccessModalBody } from '../elements/SuccessModalBody'
import { OpenBankingAutoConnectModalSteps } from '../enums/openBankingAutoConnectModalSteps'

export const openBankingAutoConnectModalSteps: ModalStates<OpenBankingAutoConnectModalSteps> = [
  {
    id: OpenBankingAutoConnectModalSteps.Loading,
    modalBody: <LoadingModalBody />,
  },
  {
    id: OpenBankingAutoConnectModalSteps.Success,
    modalBody: <SuccessModalBody />,
  },
  {
    id: OpenBankingAutoConnectModalSteps.Error,
    modalBody: <ErrorModalBody />,
  },
  {
    id: OpenBankingAutoConnectModalSteps.ConnectionFailed,
    modalBody: <ConnectionFailedModalBody />,
  },
]
